"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrapperBronsonFormInput = exports.WrapperBronsonFormSelect = exports.handleChange = exports.renderError = exports.renderLabel = exports.validateField = exports.getErrorMessage = exports.generateElementId = void 0;
const React = require("react");
const react_1 = require("@tippyjs/react");
const Input_1 = require("../Components/FormElements/Input");
const Select_1 = require("../Components/FormElements/Select");
const form_validations_1 = require("./validations/form-validations");
const form_validations_type_1 = require("./validations/form-validations.type");
const constants_1 = require("./constants");
const generateElementId = (id = '') => id ? id : `dh-element-${Math.random() * constants_1.oneThousand}`;
exports.generateElementId = generateElementId;
const getErrorMessage = (key, language, errorMessages) => {
    const errorKey = errorMessages
        ? errorMessages.findIndex((elem) => elem.validationKey === key)
        : -constants_1.one;
    if (errorKey > -constants_1.one) {
        return errorMessages ? errorMessages[errorKey].errorMessage : '';
    }
    else if (form_validations_type_1.BronsonFormErrorMessagesEnum[key][language]) {
        return form_validations_type_1.BronsonFormErrorMessagesEnum[key][language];
    }
    else
        return 'Existe un error en el campo';
};
exports.getErrorMessage = getErrorMessage;
const validateField = (value, currentErrorMessages, validations, condition, language = form_validations_type_1.BronsonLanguages.ESP, startsWith) => {
    let hasError = false;
    let errorMessages = [];
    if (validations && validations.length) {
        validations.forEach((validationKey) => {
            let currentErrorMessage = (0, exports.getErrorMessage)(validationKey, language);
            if (validationKey !== form_validations_type_1.BronsonFormValidationsEnum.hasMinLength &&
                validationKey !== form_validations_type_1.BronsonFormValidationsEnum.startsWith &&
                form_validations_1.BronsonValidations[validationKey](value)) {
                errorMessages = errorMessages.filter((err) => err !== currentErrorMessage);
            }
            else if (condition &&
                validationKey === form_validations_type_1.BronsonFormValidationsEnum.hasMinLength &&
                form_validations_1.BronsonValidations[validationKey](value, condition)) {
                errorMessages = errorMessages.filter((err) => err !== currentErrorMessage);
            }
            else if (startsWith &&
                validationKey === form_validations_type_1.BronsonFormValidationsEnum.startsWith &&
                form_validations_1.BronsonValidations[validationKey](value, startsWith)) {
                errorMessages = errorMessages.filter((err) => err !== currentErrorMessage);
            }
            else {
                hasError = true;
                if (condition &&
                    validationKey === form_validations_type_1.BronsonFormValidationsEnum.hasMinLength) {
                    currentErrorMessage = currentErrorMessage.replace('{minLength}', condition.toString());
                }
                if (startsWith &&
                    validationKey === form_validations_type_1.BronsonFormValidationsEnum.startsWith) {
                    currentErrorMessage = currentErrorMessage.replace('{startsWith}', startsWith.toString());
                }
                errorMessages = currentErrorMessages.includes(currentErrorMessage)
                    ? [...currentErrorMessages]
                    : [...currentErrorMessages, currentErrorMessage];
            }
        });
    }
    return { hasError, errorMessages };
};
exports.validateField = validateField;
const checkRequired = (validations) => {
    if (!validations || !validations.length)
        return false;
    return validations.includes(form_validations_type_1.BronsonFormValidationsEnum.required);
};
const renderTooltip = (tooltip, id) => (React.createElement("span", { id: `${id}-tooltip`, className: 'u-ml-xsmall' },
    React.createElement(react_1.default, { content: tooltip },
        React.createElement("span", null,
            React.createElement("i", { className: 'c-icon c-icon--[semantic-faq] c-icon--xxsmall', "aria-hidden": 'true', role: 'img' })))));
const renderLabel = (labelText, validations, tooltip, id) => {
    if (labelText && !checkRequired(validations)) {
        return (React.createElement(React.Fragment, null,
            React.createElement("label", null, labelText),
            !!tooltip && !!id && renderTooltip(tooltip, id)));
    }
    else if (labelText && checkRequired(validations)) {
        return (React.createElement(React.Fragment, null,
            React.createElement("label", null,
                labelText,
                React.createElement("span", { style: { color: 'red' } }, "\u00A0*")),
            !!tooltip && !!id && renderTooltip(tooltip, id)));
    }
    else
        return React.createElement(React.Fragment, null);
};
exports.renderLabel = renderLabel;
const renderError = (hasError, errorMessages, customError, customErrorMessage) => {
    if (customError || hasError || errorMessages.length)
        return (React.createElement("div", { className: 'c-error-message' }, customErrorMessage ? (customErrorMessage) : (React.createElement("ul", null, errorMessages.map((error, index) => (React.createElement("li", { key: index, className: 'u-mb-xsmall' }, error)))))));
    else
        return React.createElement(React.Fragment, null);
};
exports.renderError = renderError;
const handleChange = (event, errorMessages, setErrorMessages, setError, callback, validations, isUppercase = false, isPhoneNumber = false, condition, language = form_validations_type_1.BronsonLanguages.ESP, startsWith) => {
    if (isPhoneNumber) {
        const inputValue = event.currentTarget.value.replace(/\s/g, '');
        if (inputValue.length === constants_1.ten) {
            const reg = /\D*(\d{3})\D*(\d{3})\D*(\d{4})\D*/;
            event.currentTarget.value = inputValue.replace(reg, '$1 $2 $3');
        }
    }
    const fieldStatus = (0, exports.validateField)(event.currentTarget.value, errorMessages, validations, condition, language, startsWith);
    setErrorMessages(fieldStatus.errorMessages);
    setError(fieldStatus.hasError);
    const bronsonEvent = {
        value: isUppercase
            ? event.currentTarget.value.toUpperCase()
            : event.currentTarget.value,
        hasError: fieldStatus.hasError,
        event,
    };
    if (callback)
        callback(bronsonEvent);
};
exports.handleChange = handleChange;
const WrapperBronsonFormSelect = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(Select_1.BronsonFormSelect, Object.assign({}, props), children);
};
exports.WrapperBronsonFormSelect = WrapperBronsonFormSelect;
const WrapperBronsonFormInput = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(Input_1.BronsonFormInput, Object.assign({}, props), children);
};
exports.WrapperBronsonFormInput = WrapperBronsonFormInput;
